/**
 * support for replacing Sub Menus with personalized data
 */

// Example data:
// {
//   menu:'top-recipes',
//   cta: {
//     text: 'View More',
//     link: 'https:\/\/www.kingsford.com\/recipes\/top-recipes\/',
//   },
//   items: [
//     {
//       "id": "1",
//       "name":"Grilled Ribeye #1",
//       "url":"https:\/\/kingsford.lndo.site\/recipes\/grilled-ribeye\/",
//       "image_url":"https:\/\/www.kingsford.com\/wp-content\/uploads\/2023\/05\/Grilled-Ribeye-1_cc1_00000000_desktop2x.jpg",
//       "rating":"5",
//     },
//     {
//       "id": "2",
//       "name":"Grilled Ribeye #2",
//       "url":"https:\/\/www.kingsford.com\/recipes\/grilled-venison-burger-with-cherry-salsa\/",
//       "image_url":"https:\/\/www.kingsford.com\/wp-content\/uploads\/2023\/05\/Grilled-Ribeye-1_cc1_00000000_desktop2x.jpg",
//       "rating":"4.5",
//     },
//     {
//       "id": "3",
//       "name":"Grilled Ribeye #3",
//       "url":"https:\/\/www.kingsford.com\/recipes\/grilled-venison-burger-with-cherry-salsa\/",
//       "image_url":"https:\/\/www.kingsford.com\/wp-content\/uploads\/2023\/05\/Grilled-Ribeye-1_cc1_00000000_desktop2x.jpg",
//       "rating":"4.5",
//     },
//     {
//       "id": "4",
//       "name":"Grilled Ribeye #4",
//       "url":"https:\/\/www.kingsford.com\/recipes\/grilled-venison-burger-with-cherry-salsa\/",
//       "image_url":"https:\/\/www.kingsford.com\/wp-content\/uploads\/2023\/05\/Grilled-Ribeye-1_cc1_00000000_desktop2x.jpg",
//       "rating":"4.5",
//     }
//   ]
// }

import {buttonFilledSvg, buttonOutlineSvg} from "../app";

/**
 * Update markup with new data
 * @param id element to update
 * @param data replacement data
 */
function replaceMenuItems(data) {
    if(Electro.DEBUG) {
      console.info('replaceMenuItems()');
    }

    try {
        const sections = document.querySelectorAll(`[data-menu-name="${data.menu}"]`);

        if (data.items.length > 4) {
          return;
        }

        /// /////////////////////////////
        // Start adding the items.
        /// /////////////////////////////
        sections.forEach((section) => {
          section.innerHTML = "";
          data.items.slice(-4).forEach((item) => {
            const menuItem = createMenuItem(item);
              if(menuItem){
                  section.appendChild(menuItem);
              }
          });
          const menuCTA = createMenuCTA(data.cta);
          section.appendChild(menuCTA);
        });

        /// /////////////////////////////////////////
        /// // Resolve the pre-defined Promise
        /// /////////////////////////////////////////
        window.breinifyHasUpdatedDOMResolve();
    } catch (e) {
        console.warn(e);
        window.breinifyHasUpdatedDOMReject();
    }
}

/**
 * @param item data for slide
 * @returns {*} markup for slide
 */
const createMenuItem = (item) => {
    const menuItem = document.createElement('span');

    let ratingContent = '';
    if (item.rating > 0) {
      ratingContent = `
        <div class="c-product-link__rating default e-rating">
          <svg class="e-rating__icon e-icon" aria-hidden="true" focusable="false" role="img"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="1.125em" height="1.125em">
            <path fill="currentColor" d="M6.83,5.63l1.97-4.14c.42-.87,1.66-.89,2.09-.02l2.09,4.18c.18.36.53.6.92.64l4.63.47c.99.1,1.4,1.31.68,2l-3.41,3.24c-.28.27-.41.66-.34,1.04l.82,4.78c.16.95-.84,1.68-1.69,1.22l-4.2-2.25c-.35-.19-.77-.18-1.11,0l-3.99,2.2c-.85.47-1.87-.25-1.71-1.21l.79-4.66c.06-.36-.05-.74-.31-1l-3.29-3.39c-.67-.7-.25-1.86.71-1.96l4.42-.47c.4-.04.75-.29.93-.66Z"/>
          </svg>
          <span class="e-rating__rating">${item.rating}</span>
        </div>`
    }

    // menuItem.innerHTML = `
    //   <a id="${item.id}" class="menu-item menu-item-type-post_type menu-item-object-kfd_recipe current-menu-item menu-item-18716 kingsford-header__global-wrapper__navigation__list-item__submenu__grid-item  align--left c-product-link" href="${item.url}">
    //     <div class="c-product-link__thumbnail-wrapper">
    //       <div class="c-product-link__overlay"></div>
    //       <picture class="c-product-link__picture e-picture e-picture--1/1-ratio e-picture--rounded-medium e-picture--border-none">
    //         <img src="${item.image_url}?quality=50" alt="">
    //       </picture>
    //
    //       <button class="c-product-link__button e-button e-button--blue-flame-on-dark e-button--large" type="button">
    //         <span class="e-button__background outline">${buttonOutlineSvg}</span>
    //         <span class="e-button__background filled">${buttonFilledSvg}</span>
    //         <span class="e-button__copy">View Recipe</span>
    //       </button>
    //     </div>
    //     <p class="c-product-link__title">${item.name}</p>
    //     ${ratingContent}
    //   </a>
    // `;
    menuItem.innerHTML = `
      <a id="${item.id}" class="menu-item menu-item-type-post_type menu-item-object-kfd_recipe current-menu-item menu-item-18716 kingsford-header__global-wrapper__navigation__list-item__submenu__grid-item  align--left c-product-link" href="${item.url}">
        <div class="c-product-link__thumbnail-wrapper">
          <div class="c-product-link__overlay"></div>
          <picture class="c-product-link__picture e-picture e-picture--1/1-ratio e-picture--rounded-medium e-picture--border-none">
            <img src="${item.image_url}?quality=50" alt="">
          </picture>
        </div>
        <p class="c-product-link__title">${item.name}</p>
        ${ratingContent}
      </a>
    `;

    return menuItem;
};

/**
 * @param item data for slide
 * @returns {*} markup for slide
 */
const createMenuCTA = (cta) => {
  const ctaLink = cta.link ? cta.link : "https://www.kingsford.com/recipes/top-recipes/";
  const ctaText = cta.text ? cta.text : "View More";

  const menuCTA = document.createElement('div');
  menuCTA.classList.add('kingsford-header__global-wrapper__navigation__list-item__submenu__full-width-wrapper');
  // menuCTA.innerHTML = `
  //   <a class="e-button e-button--filled-on-white e-button--large" href="${ctaLink}" target="_self">
  //     <span class="e-button__background outline">${buttonOutlineSvg}</span>
  //     <span class="e-button__background filled">${buttonFilledSvg}</span>
  //     <span class="e-button__copy">${ctaText}</span>
  //   </a>
  // `;

  return menuCTA;
};

export default class HeaderMenuItems {
    constructor() {
        if(Electro.DEBUG) {
          console.info('HeaderTopRecipes.constructor()');
        }

        // define a promise without resolving it
        window.breinifyHasUpdatedDOM = new Promise((res, rej) => {
            window.breinifyHasUpdatedDOMResolve = res;
            window.breinifyHasUpdatedDOMReject = rej;
        });

        window.replaceMenuItems = replaceMenuItems;
    }
}
